import {  PriceCheck, SendRounded, Person } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, DatePickerInputWithLabel } from "../../../components/form/custom-imputs";
import { AxiosInstance, DateTimeFormatString, FormatPrice } from "../../../utils/constants";
import * as yup from "yup";
import { Line } from 'react-chartjs-2';
import { yellow } from "@mui/material/colors";
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from "react-hook-form";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);


const schemaFilter = yup.object({
  producto:yup.mixed().required(),
  fecha_inicio:yup.mixed().required(),
  fecha_fin:yup.mixed().required().test(
    "_not_equal",
    "La fecha debe ser igual o mayor a la anterior",
    function(item){

       return  !dayjs(item).startOf("month").isBefore(dayjs(this.parent.fecha_inicio).startOf("month"),"month")
   
    }
 ),

}).required();




const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:"",
  proveedor:null,
  estado_cesta:"TODAS"
};




const defaultCasoData = {
  descripcion:"",
  ind_tipo_alerta:"COMPRA",
  ind_estado:"ABIERTO",
  id_entidad:null
};

const compactChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        boxWidth: 12,
        font: { size: 11 }
      }
    }
  }
};

const optionsPrecio = {
  ...compactChartOptions,
  plugins: {
    ...compactChartOptions.plugins,
    title: {
      display: true,
      text: 'Variacion de precio (KG)',
      font: { size: 13 }
    },
  },
};

const optionsVolumen = {
  ...compactChartOptions,
  plugins: {
    ...compactChartOptions.plugins,
    title: {
      display: true,
      text: 'Variacion de volumen de compra (KG)',
      font: { size: 13 }
    },
  },
};

export const GestionGeneralCompras = ({
  fechaSeleccionada
})=>{

  const { control, set, register, watch, handleSubmit, setValue, formState: { errors, }, setError } = useForm({
    resolver: yupResolver(schemaFilter),
    defaultValues: {
      fecha_inicio:dayjs().add(-3,"month").startOf("month"),
      fecha_fin:dayjs().startOf("month"),
      producto:null
    }
});
const {dispatch,store:{profile}} = useContext( AppContext );
const [productoList,setProductoList] = useState([]);
const [configGrafico,setConfigGrafico] = useState({
  labels:[],
  datasetPrecio:[],
  datasetVolumen:[],
  precio_compra:0,
  precio_cotizado:0,
  comprador:"",
  listado_compras:[]
});


const onSearchVehiculo = (e,value)=>{
  console.log({e,value});
 if (value.length > 1 ){

  AxiosInstance.post("maestros/get-producto-filter",{
    search_query:value,
  }).then(({data})=>{

    setProductoList(data.value);
  }).catch(err=>{

  }).finally(()=>{

  });
 }


}
      

const onSubmitForm = (data)=>{
    const  MonthNumber = dayjs(data.fecha_fin).diff(data.fecha_inicio,"months");
    const MonthList = [];
    let incremental = 0;
    let currentMonth = dayjs(data.fecha_inicio).startOf("month");


    dispatch({
      type:ActionTypes.setLoadingPage,
      data:true
    });

  do{

    MonthList.push({
      label:currentMonth.format("MMMM"),
      inicio:currentMonth.startOf("month").format(DateTimeFormatString),
      fin:currentMonth.endOf("month").format(DateTimeFormatString),
      dataSet:[]
    });

    currentMonth = currentMonth.add(1,"month");
    incremental +=1;

  }while( !currentMonth.isAfter(dayjs(data.fecha_fin),"month")  )

  
  console.log({data,MonthNumber,MonthList,is_equal:currentMonth.isSame(dayjs(data.fecha_fin),"month")});

  AxiosInstance.post("auditoria/consultar-reporte-compra",{
    meses:MonthList,
    producto:data.producto.value
  }).then( ({data})=>{
   let reportData = {
    labels:[],
    datasetPrecio:[
      {
        label: 'Precio',
        data:[],
        borderColor: '#BF5627',
        backgroundColor: '#BF5627',
      },
    ],
    datasetVolumen:[
      {
        label: 'Volumen',
        data: [],
        borderColor: '#1B7A4A',
        backgroundColor: '#1B7A4A',
      },
    ],
    precio_compra:FormatPrice(data.ultimo_precio_compra,2),
    precio_cotizado:FormatPrice(data.ultimo_precio_cotizacion,2),
    comprador:data.comprador,
    listado_compras:data.listado_compras
   }
   data.data_set.forEach(data_set_item => {
    reportData.labels.push(data_set_item.label);
    reportData.datasetPrecio[0].data.push(data_set_item.dataSet.map(value_item=>Number(value_item.valor_kg)));
    reportData.datasetVolumen[0].data.push(data_set_item.dataSet.map(value_item=>Number(value_item.cantidad_ordenada_prod_kg)));
    });
    console.log({reportData});
    setConfigGrafico(reportData);

  } ).catch(e=>{

  }).finally(()=>{

    dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });

  });


}


const columnsTable = [
  {
  
    key:"id",
    keyValue:"id",
    label:"#",
    headerRender:(props)=>props.label,
    bodyRender:(props)=>props.col_index,
    typeRow:"string",
    sort:false,
    sortFunction:()=>{},
    sortStatus:"", 

   },
   {
  
    key:"proveedor",
    keyValue:"proveedor",
    label:"Proveedor",
    headerRender:(props)=>props.label,
    bodyRender:(props)=>props.value,
    typeRow:"string",
    sort:false,
    sortFunction:()=>{},
    sortStatus:"", 

   },
  {
  
   key:"fecha_compra",
   keyValue:"fecha_compra",
   label:"Fecha y hora",
   headerRender:(props)=>props.label,
   bodyRender:(props)=>props.value,
   typeRow:"string",
   sort:false,
   sortFunction:()=>{},
   sortStatus:"", 

  },
  {
  
    key:"cantidad_compra",
    keyValue:"cantidad_compra",
    label:"Cantidad",
    headerRender:(props)=>props.label,
    bodyRender:(props)=>`${props.info.total_un_empaques}  ${props.info.nombre_unidad_medida}`,
    typeRow:"string",
    sort:false,
    sortFunction:()=>{},
    sortStatus:"", 

   },
   {
  
    key:"valor_um",
    keyValue:"valor_um",
    label:"Valor (UM)",
    headerRender:(props)=>props.label,
    bodyRender: (props) =>`$ ${FormatPrice(props.value,2)} COP` ,
    typeRow:"string",
    sort:false,
    sortFunction:()=>{},
    sortStatus:"", 

   },
   {
  
    key:"valor_kg",
    keyValue:"valor_kg",
    label:"Valor (KG)",
    headerRender:(props)=>props.label,
    bodyRender: (props) =>`$ ${FormatPrice(props.value,2)} COP` ,
    typeRow:"string",
    sort:false,
    sortFunction:()=>{},
    sortStatus:"", 

   },
   {
  
    key:"valor_mercancia",
    keyValue:"valor_mercancia",
    label:"Valor total",
    headerRender:(props)=>props.label,
    bodyRender: (props) =>`$ ${FormatPrice(props.value,2)} COP` ,
    typeRow:"string",
    sort:false,
    sortFunction:()=>{},
    sortStatus:"", 

   }
  
];


    const kpiCardSx = {
      height: '100%'
    };
    const kpiAvatarSx = { width: 28, height: 28 };
    const kpiHeaderSx = {
      pb: 0,
      '& .MuiCardHeader-title': { fontSize: '0.75rem', lineHeight: 1.2 },
      '& .MuiCardHeader-avatar': { mr: 1 }
    };

    return (<>


   

   
    <Grid container spacing={2} >

      <Grid container item xs={12} spacing={2} alignItems="stretch">
        <Grid item xs={12} md={4} sx={{ maxWidth: { md: '35%' }, flexBasis: { md: '35%' } }}>
            <Card>
            <Typography sx={{textAlign:"center", pt: 1}} variant="subtitle2" >FILTRO DE DATOS</Typography>
              <CardContent sx={{display:"flex", pt: 0.5, pb: 1}} >
               
                 <form onSubmit={handleSubmit(onSubmitForm)} style={{width:'100%'}} >
                   <Controller
                    control={control}
                    name="fecha_inicio"
                    
                    render={ props=><DatePickerInputWithLabel
                      label='Fecha de inicio'
                      size='small'
                      views={['year','month']}
                      errorMessage={errors[props.field.name]?.message}
                      {...props.field}
                      {...props}
                      />} 
                   
                   />
                     <Controller
                    control={control}
                    name="fecha_fin"
                    render={ props=><DatePickerInputWithLabel
                      label='Fecha de corte'
                      size='small'
                      views={['year','month']}
                      errorMessage={errors[props.field.name]?.message}
                      {...props.field}
                      {...props}
                      />} 
                   
                   />
                                        <Controller
                    control={control}
                    name="producto"
                    render={({field})=><AutoCompleteInputWithLabel 
                    size='small' 
                    fullWidth
                    label="Producto"  
                    options={productoList || []}
                    noOptionsText="Lista vacia"
                    errorMessage={errors?.[field.name]?.message}  {...field} 
                    onInputChange={onSearchVehiculo}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    filterOptions={(x) => x}
                    {...field}
                    
                    />}
                   
                   />

                  <CardActions sx={{px: 0}}>
                  <Button fullWidth variant="contained" size="small" type="submit" >Aplicar filtros</Button>
                  </CardActions>

                 </form>
              </CardContent>
            </Card>
        </Grid>

        <Grid item xs={12} md={8} sx={{ maxWidth: { md: '65%' }, flexBasis: { md: '65%' } }}>
          <Grid container spacing={1} alignItems="stretch">
            <Grid item xs={12} sm={4}>
              <Card sx={kpiCardSx}>
                <CardHeader
                  sx={kpiHeaderSx}
                  avatar={
                    <Avatar sx={{ ...kpiAvatarSx, bgcolor: 'success.main' }}>
                      <PriceCheck fontSize="small" />
                    </Avatar>
                  }
                  title="Ult. Precio de compra (KG)"
                />
                <CardContent sx={{ pt: 0.5, pb: '8px !important' }}>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>$ {configGrafico.precio_compra} COP</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Card sx={kpiCardSx}>
                <CardHeader
                  sx={kpiHeaderSx}
                  avatar={
                    <Avatar sx={{ ...kpiAvatarSx, bgcolor: 'tertiary.main' }}>
                      <SendRounded fontSize="small" />
                    </Avatar>
                  }
                  title="Ult. Precio cotizado (KG)"
                />
                <CardContent sx={{ pt: 0.5, pb: '8px !important' }}>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>$ {configGrafico.precio_cotizado} COP</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Card sx={kpiCardSx}>
                <CardHeader
                  sx={kpiHeaderSx}
                  avatar={
                    <Avatar sx={{ ...kpiAvatarSx, bgcolor: yellow[500] }}>
                      <Person fontSize="small" />
                    </Avatar>
                  }
                  title="Comprador"
                />
                <CardContent sx={{ pt: 0.5, pb: '8px !important' }}>
                  <Box sx={{ textAlign: "center", overflow: "hidden", textOverflow: "ellipsis" }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{configGrafico.comprador}</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container item xs={12} spacing={2}>
        <Grid item xs={12} md={6}>
          <Box sx={{ height: 240 }}>
            <Line
              options={optionsPrecio}
              data={{ labels: configGrafico.labels, datasets: configGrafico.datasetPrecio }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ height: 240 }}>
            <Line
              options={optionsVolumen}
              data={{ labels: configGrafico.labels, datasets: configGrafico.datasetVolumen }}
            />
          </Box>
        </Grid>
      </Grid>

        <Grid item sm={12} xs={12} md={12} >
                    <Typography variant="h6" >
                      Ultimas compras realizadas
                    </Typography>

                    <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
                
                {
                  columnsTable.map((colum,colum_index) => <TableCell key={colum.key} >
                    {<colum.headerRender colum_index={colum_index} label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {configGrafico.listado_compras.map( (prod,prod_index)=>
                  [
                    <TableRow key={prod.key_item}  >
                      
                    {
                      columnsTable.map((Col,col_index)=>
                        <TableCell key={Col.key}  >
                          {<Col.bodyRender col_index={prod_index+1}  key={prod.key} value={prod[Col.keyValue]} info={prod} />}
                       </TableCell>)
                    }

                  </TableRow>
                  ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
         

        </Grid>
    </Grid>
    </>)

}